import type { FC } from 'react';

import React from 'react';
import Image from '@wix/thunderbolt-elements/src/components/Image/viewer/Image';
import { Avatar as AvatarWUT } from 'wix-ui-tpa/cssVars';

import VectorImage from '../../../../../VectorImage/viewer/VectorImage';
import { AvatarState } from '../../../../LoginSocialBar.types';
import { DEFAULT_AVATAR_SVG, defaultCompProps } from '../../../../constants';
import { MemberInitials } from './memberInitials';

interface AvatarProps {
  id: string;
  name?: string;
  className?: string;
  url?: string;
  state?: AvatarState;
  useNewMemberInitialsAvatar: boolean;
}

export const Avatar: FC<AvatarProps> = ({
  state,
  url,
  id,
  name,
  className,
  useNewMemberInitialsAvatar,
}) => {
  if (state === AvatarState.Initials) {
    if (useNewMemberInitialsAvatar) {
      return (
        <MemberInitials
          dataHook={`initialsAvatar-${id}`}
          className={className}
          name={name}
        />
      );
    }

    return (
      <AvatarWUT
        data-hook={`initialsAvatar-${id}`}
        className={className}
        name={name}
      />
    );
  }

  if (state === AvatarState.Image && url) {
    return (
      <Image
        id={`customAvatar-${id}`}
        containerId={id}
        width={defaultCompProps.iconSize}
        height={defaultCompProps.iconSize}
        displayMode="fill"
        uri={url}
        name=""
        alt=""
        className={className}
      />
    );
  }

  return (
    <VectorImage
      id={`defaultAvatar-${id}`}
      className={className}
      ariaAttributes={{ hidden: true }}
      svgContent={DEFAULT_AVATAR_SVG}
      shouldScaleStroke={false}
      withShadow={false}
    />
  );
};
